import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DropDownRequest, DropDownResponse } from 'src/app/Models/DropDwon/DropDownRequest';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { DropDownService } from 'src/app/Services/DropDown/dropdownService';
import { ReportsService } from '../../../Services/Reports/reports.service';

@Component({
  selector: 'app-dsurequirement-report',
  templateUrl: './dsurequirement-report.component.html',
  styleUrls: ['./dsurequirement-report.component.css']
})
export class DSURequirementReportComponent implements OnInit {

  @ViewChild('yearSelect') yearSelect;
  @ViewChild('year') year;
  public userId: string;
  public roleId: string;
  public loader: string="none";
  public userName: string;
 
  public YearSettings= {};
  public YearSelectedItem: YearModel[];

  public ddlRequest: DropDownRequest = new DropDownRequest();
  public ddlResponse: DropDownResponse = new DropDownResponse();
  
  defaultValue = 'none';
  constructor(private ddlServices: DropDownService,private toastr: ToastrService, private reportService: ReportsService ) 
  {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId=localStorage.getItem('dsu_roleCode');
  }
  
 
  ngOnInit() {
    this.userName = localStorage.getItem('dsu_userName');
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.ddlResponse = response.data;
                    this.ddlResponse.year=response.data.year;
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : this.ddlResponse.year[0].currentrequirementYear,
                        text: this.ddlResponse.year[0].currentrequirementYear
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems = requiredItem
                      for(var i=0;i<this.year.selectedItems.length; i++){
                          this.yearSelect.push(this.year.selectedItems[i].text)
                      }
                    this.YearSetting();
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    this.YearSetting();

  }
  YearSetting(){
    this.YearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  DownloadExcel() {
    this.loader = 'block';
    this.userId = localStorage.getItem('dsu_userId');
    let roleCode=localStorage.getItem('dsu_roleCode');
    let today = new Date();
    let month;
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    let region = '';
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.reportService.DSURequirementReport(this.userId,roleCode,year)
        .subscribe(success => {
            if (success.ok = true) {
                var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
                saveAs(blob, this.userName + "_" + year + "_DSURequirementReport_" + formattedDate + ".xlsx");
            }
            this.loader = 'none';
        }, err => {
            this.toastr.error("No data found");
            //alert("Some problem occurred while downloading file.");
            this.loader = 'none';
        });
  }

}
